/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star of life': {
    width: 16,
    height: 16,
    viewBox: '0 0 64.38 67',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M57.93 27.51l3.57-2.06 1.41-.81a2 2 0 0 0 .7-2.7l-4.91-8.53-.79-1.41a2 2 0 0 0-2.7-.7l-6.84 3.95-8.49 4.9V2.49a2 2 0 0 0-2-2H26.5a2 2 0 0 0-2 2v17.7L20.63 18l-10.06-5.85-1.41-.81a2 2 0 0 0-2.7.72l-4.91 8.52-.79 1.36a2 2 0 0 0 .72 2.7l6.84 3.95 8.51 4.91-3.89 2.25-10.06 5.8-1.41.81a2 2 0 0 0-.7 2.7l4.92 8.52.78 1.42a2 2 0 0 0 2.7.7L16 51.71l8.49-4.9v17.7a2 2 0 0 0 2 2h11.39a2 2 0 0 0 2-2v-17.7L43.75 49l10.06 5.81 1.41.81a2 2 0 0 0 2.7-.72l4.92-8.52.79-1.37a2 2 0 0 0-.72-2.7l-6.84-3.95-8.51-4.86" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/star of life.js